import MDBox from 'components/MDBox';
import { styled } from '@mui/material/styles';
import MDTypography from 'components/MDTypography';

// Layout wrapper
export const ContentWrapper = styled(MDBox)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
});

// Title
export const TitleText = styled(MDTypography)(({ isSmall }) => ({
  opacity: 0.7,
  fontWeight: 'bold',
  textTransform: 'uppercase',
  fontSize: isSmall ? '10px' : 'inherit',
}));

// Count
export const CountText = styled(MDTypography)(({ isSmall }) => ({
  marginTop: '4px',
  color: '#344767',
  fontWeight: 'bold',
  fontSize: isSmall ? '1.25rem' : '2rem',
}));

// Percentage wrapper
export const PercentageWrapper = styled(MDBox)({
  display: 'flex',
  marginTop: '4px',
  alignItems: 'center',
});

// Percentage amount
export const PercentageAmount = styled(MDTypography)(({ color }) => ({
  color: color,
  fontWeight: 'bold',
}));

// Percentage label
export const PercentageLabel = styled(MDTypography)({
  opacity: 0.7,
  marginLeft: '4px',
});

// Icon wrapper
export const IconWrapper = styled(MDBox)(
  ({ isSmall, isPlain, bgcolor, iconColor }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '12px',
    justifyContent: 'center',
    width: isSmall ? '32px' : '48px',
    height: isSmall ? '32px' : '48px',
    color: isPlain ? '#344767' : iconColor || '#1A73E8',
    backgroundColor: isPlain ? 'rgba(52, 71, 103, 0.05)' : bgcolor || '#E3F2FD',
  }),
);
